<template>
  <svg width="20"
       height="19"
       viewBox="0 0 20 19"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99121 18.7422C14.9746 18.7422 19.0879 14.6289 19.0879 9.6543C19.0879 4.67969 14.9658 0.566406 9.98242 0.566406C5.00781 0.566406 0.90332 4.67969 0.90332 9.6543C0.90332 14.6289 5.0166 18.7422 9.99121 18.7422ZM9.99121 16.9316C5.95703 16.9316 2.73145 13.6885 2.73145 9.6543C2.73145 5.62012 5.95703 2.38574 9.98242 2.38574C14.0166 2.38574 17.2598 5.62012 17.2686 9.6543C17.2773 13.6885 14.0254 16.9316 9.99121 16.9316ZM7.44238 8.8457C7.96094 8.8457 8.40039 8.38867 8.40039 7.74707C8.40039 7.10547 7.96094 6.64844 7.44238 6.64844C6.93262 6.64844 6.50195 7.10547 6.50195 7.74707C6.50195 8.38867 6.93262 8.8457 7.44238 8.8457ZM12.5664 8.8457C13.085 8.8457 13.5244 8.38867 13.5244 7.74707C13.5244 7.10547 13.085 6.64844 12.5664 6.64844C12.0479 6.64844 11.626 7.10547 11.626 7.74707C11.626 8.38867 12.0479 8.8457 12.5664 8.8457ZM6.90625 12.1592C6.90625 12.748 8.14551 13.9697 9.98242 13.9697C11.8281 13.9697 13.0674 12.748 13.0674 12.1592C13.0674 11.9482 12.8564 11.8428 12.6631 11.9395C12.0215 12.2734 11.2656 12.6689 9.98242 12.6689C8.70801 12.6689 7.95215 12.2734 7.31055 11.9395C7.11719 11.8428 6.90625 11.9482 6.90625 12.1592Z"
          :fill="color"/>
  </svg>

</template>
<script>
export default {
  name: 'PersonalityIcon',
  props: {
    width: {
      type: Number,
      default: 10
    },
    height: {
      type: Number,
      default: 10
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }
}
</script>
